import { AutogenLayoutAccessAdmin } from "./autogen/AutogenLayoutAccessAdmin";
import {  ClickEvent, ListItemType,  TableRowDisplayEvent,  DataSourceExecutionEvent,  DataSourceModeChangeEvent,  DataDisplayEvent, Checkbox, Switch,  TableSelectionEvent, TableRow, DataSourceMode,  ChangeEvent,  DropdownSelectionEvent, DataSourceAction, SelectionType, RadioGroup,  RadioButtonSelectionEvent } from "@mcleod/components";
import { DropdownItem, Textbox, DataSource } from "@mcleod/components";
import { ModelRow, Api } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";
import { Label, Layout, Panel } from "@mcleod/components";
import { RadioGroupProps } from "@mcleod/components";

export class AccessAdmin extends AutogenLayoutAccessAdmin {

  private timer: any;
  private selectedApp = null;
  private scanneridUpdate= false;

  override onLoad() {
    //console.log(this);
    this.HideAllTabs();
  }

  HideAllTabs()
  {
    for( const tab of this.tabsetAccessAdmin )
      tab.visible = false;
    for( const lbl of this.panelLeft.components )
      lbl.backgroundColor = "";
  }

/** This is an event handler for the onClick event of all labels on panelLeft. */
  async labelsOnClick(event: ClickEvent)
  {
    this.HideAllTabs();
    const lbl: any = event.target;
    lbl.backgroundColor = "primary.light";
    for( let i = 0; i < this.panelLeft.getComponentCount(); i++ )
    {
      if( this.panelLeft.components[i] == lbl )
      {
        this.tabsetAccessAdmin.selectedIndex = i;
        break;
      }
    }
    this.tabsetAccessAdmin.getActiveTab().visible = true;
    if( this.tabsetAccessAdmin.getActiveTab().caption == "Modules" )
      await this.sourceDimodules.search( );
    else if( this.tabsetAccessAdmin.getActiveTab().caption == "Modules Access" )
      await this.sourceDimodules.search( { dimod_secured: "Y" } );
    else if( this.tabsetAccessAdmin.getActiveTab().caption == "Remote In/Out Boxes" )
      await this.sourceDirembox.search( );
    else if( this.tabsetAccessAdmin.getActiveTab().caption == "Remote In/Out Box Access" )
    {
      if( this.tbldidb.selectedIndex < 0 )
        this.tbldidb.selectedIndex = 0;
      if( this.tblUsers1.selectedIndex < 0 )
        this.tblUsers1.selectedIndex = 0;
    }
    else if( this.tabsetAccessAdmin.getActiveTab().caption == "Group Access" )
    {
      this.pnl5GA.visible = false;
      await this.sourceImglistvalues.search( { lv_table: "diaccess" } );
    }
    else if( this.tabsetAccessAdmin.getActiveTab().caption == "Rendition Access" )
      await this.sourceImglistvalues.search( { lv_table: "direnaccess", lv_value: "<>FX" } );
    else if( this.tabsetAccessAdmin.getActiveTab().caption == "REST API Access" )
      this.tblProjectsRA.clearRows();
    else if( this.tabsetAccessAdmin.getActiveTab().caption == "Web Module Access" )
      this.tblWebModulesWMA.clearRows();
  }

/** This is an event handler for the onRowDisplay event of tblWorkflowAlias. */
  tblWorkflowAliasOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("tbImapAppname") as Textbox;
    const appidtxtbox = event.getTableRow().findComponentById("textboxDiwfaAppid") as Textbox;
    for( let i = 0; i < this.sourceImgApps.rowCount; i++ )
    {
      this.sourceImgApps.rowIndex = i;
      const row: any = this.sourceImgApps.activeRow.data;
      if( row.imap_appid == appidtxtbox.text )
      {
        let appname: string = row.imap_appname;
        appname = appname.replace( "&", "" );
        txtbox.text = appname;
        break;
      }
    }
    // let appname: string = txtbox.text
    // appname = appname.replace("&","");
    // txtbox.setProps({ text: appname, color: "success" });
  }

/** This is an event handler for the onRowDisplay event of tblGroup. */
  tblGroupOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("tbxVgType") as Textbox;
    let type: string = txtbox.text
    const tbGroupType = event.getTableRow().findComponentById("tbGroupType") as Textbox;
    let desc=null;
    if( type == "A" )
      desc = "API";
    else if( type == "M" )
      desc = "Mobile";
    else //if( type == "D" )
    {
      desc = "Desktop";
      type = "D";
    }
    //txtbox.setProps({ text: type, color: "success" });
    //tbGroupType.setProps({ text: desc, color: "success" });
    tbGroupType.text = desc; //to display the text in table
  }

/** This is an event handler for the onRowDisplay event of tblUsers. */
  tblUsersOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDigroupType2") as Textbox;
    let type: string = txtbox.text
    const tbGroupType = event.getTableRow().findComponentById("tbGroupType2") as Textbox;
    let desc=null;
    if( type == "A" )
      desc = "API";
    else if( type == "M" )
      desc = "Mobile";
    else //if( type == "D" )
    {
      desc = "Desktop";
      type = "D";
    }
    //txtbox.setProps({ text: type, color: "success" });
    //tbGroupType.setProps({ text: desc, color: "success" });
    tbGroupType.text = desc; //to display the text in table

    const tbUStatus = event.getTableRow().findComponentById("textboxDiuserStatus") as Textbox;
    const tbuscolor = (tbUStatus.text == "Active") ? "success" : "error";
    tbUStatus.setProps({ color: tbuscolor });
  }

/** This is an event handler for the onRowDisplay event of tblModules. */
  tblModulesOnRowDisplay(event: TableRowDisplayEvent) {
    const chkbox = event.getTableRow().findComponentById("checkboxDimodSecured") as Checkbox;
    chkbox.printable = false;   //to display a checkbox instead of text
  }

/** This is an event handler for the onClick event of checkboxDimodSecured. */
  async checkboxDimodSecuredOnClick(event: ClickEvent) {
    const chkbox: any = event.target;
    chkbox.checked = !chkbox.checked;
    const row = chkbox.row.data;
    const modname = row._data.dimod_name;
    const resp = await row.post();     //update current row
    if( resp != null && modname != null && !chkbox.checked )
      this.deleteModSecRecords( modname );
  }

/** This is an event handler for the onRowDisplay event of tblGroups. */
  tblGroupsOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("tbDigroupType") as Textbox;
    let type: string = txtbox.text
    //const tbGroupType = event.getTableRow().findComponentById("tbGroupType") as Textbox;
    let desc=null;
    if( type == "A" )
      desc = "API";
    else if( type == "M" )
      desc = "Mobile";
    else //if( type == "D" )
    {
      desc = "Desktop";
      type = "D";
    }
    //txtbox.setProps({ text: type, color: "success" });
    //txtbox.setProps({ text: desc, color: "success" });
    txtbox.text = desc; //to display the text in table
    //display/select 1st gid modules
    if( this.tblGroups.selectedIndex == -1 )
    {
      this.tblGroups.selectedIndex = 0;
      this.tblGroupsOnSelect(null);
    }
  }

/** This is an event handler for the onSelect event of tblGroups. */
  async tblGroupsOnSelect(event: TableSelectionEvent) {
    const row: any = this.tblGroups.selectedRow.data._data;
    await this.sourceDimodsec.search( { dims_gid: row.digroup_gid } );
    await this.sourceDimodules.search( { dimod_secured: "Y" } );
  }

/** This is an event handler for the onRowDisplay event of tblModSec. */
  tblModSecOnRowDisplay(event: TableRowDisplayEvent) {
    const chkbox = event.getTableRow().findComponentById("cbmodsec") as Checkbox;
    chkbox.printable = false;   //to display a checkbox instead of text
    const dimodname = event.getTableRow().findComponentById("tbDimodName") as Textbox;
    const dimsname = event.getTableRow().findComponentById("tbDimsName") as Textbox;
    dimsname.text = dimodname.text;
    chkbox.checked = false;
    for( let i=0; i < this.sourceDimodsec.rowCount; i++ )
    {
      this.sourceDimodsec.rowIndex = i;
      if( this.sourceDimodsec.activeRow.data.dims_name == dimodname.text )
      {
        chkbox.checked = true;
        break;
      }
    }
  }

/** This is an event handler for the onClick event of cbmodsec. */
  async cbmodsecOnClick(event: ClickEvent) {
    const trow: any = this.tblGroups.selectedRow.data._data;
    const gid = trow.digroup_gid;
    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    const dimodname = row._data.dimod_name;

    const prow: any = new ModelRow("imaging/AccessAdmin/dimodsec", true);
    prow.set( "dims_gid", gid );
    prow.set( "dims_name", dimodname );
    if( !chkbox.checked )
    {   //add row
      prow.mode = DataSourceMode.ADD;
      this.sourceDimodsec.mode = DataSourceMode.ADD;
      this.sourceDimodsec.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDimodsec.post();
    }
    else
    {   //delete row
      const resp = await this.sourceDimodsec.search( prow );
      if( resp != null && this.sourceDimodsec.rowCount == 1 )
      {
        this.sourceDimodsec.rowIndex = 0;
        const recid = this.sourceDimodsec.activeRow.data.dims_recid;
        prow.set( "dims_recid", recid );
        prow.mode = DataSourceMode.NONE;
        this.sourceDimodsec.mode = DataSourceMode.NONE;
        this.sourceDimodsec.setRowsAndMode( prow.mode, [prow], null );
        this.sourceDimodsec.delete();
      }
    }
    this.tblGroupsOnSelect(null); //refresh/reload data/table display
  }

  async deleteModSecRecords( modname: string )
  {   //delete all rows
    let resp = await this.sourceDimodsec.search( {dims_name: modname} );
    while( resp != null && this.sourceDimodsec.rowCount > 0 )
    {
      this.sourceDimodsec.rowIndex = 0;
      const prow = this.sourceDimodsec.activeRow;
      this.sourceDimodsec.mode = DataSourceMode.NONE;
      this.sourceDimodsec.setRowsAndMode( DataSourceMode.NONE, [prow], null );
      this.sourceDimodsec.delete();
      resp = await this.sourceDimodsec.search( {dims_name: modname} ); //for some reason had to research for records
    }
  }

/** This is an event handler for the onRowDisplay event of tblRembox. */
  tblRemboxOnRowDisplay(event: TableRowDisplayEvent) {
    const swStatus = event.getTableRow().findComponentById("swStatus") as Switch;
    const swcolor = swStatus.checked ? "success" : "error";
    swStatus.setProps({ color: swcolor });
    //swStatus.printable = false;
    //swStatus.enabled = false;
    const rmbxType = event.getTableRow().findComponentById("textboxRmbxType") as Textbox;
    const tbType = event.getTableRow().findComponentById("tbType") as Textbox;
    if( rmbxType.text == "B" )
      tbType.text = "Both";
    else if( rmbxType.text == "I" )
      tbType.text = "Inbox";
    else if( rmbxType.text == "O" )
      tbType.text = "Outbox";
    else
      tbType.text = "Unknown";

    const rmbxDba = event.getTableRow().findComponentById("textboxRmbxDba") as Textbox;
    const tbDba = event.getTableRow().findComponentById("tbDba") as Textbox;
    for( let i = 0; i < this.sourceDidbalias.rowCount; i++ )
    {
      this.sourceDidbalias.rowIndex = i;
      const row: any = this.sourceDidbalias.activeRow.data;
      if( row.didb_dbalias == rmbxDba.text )
      {
        tbDba.text = row.didb_desc;
        break;
      }
    }

    const rmbxAppid = event.getTableRow().findComponentById("textboxRmbxAppid") as Textbox;
    const tbAppid = event.getTableRow().findComponentById("tbAppid") as Textbox;
    for( let i = 0; i < this.sourceImgApps.rowCount; i++ )
    {
      this.sourceImgApps.rowIndex = i;
      const row: any = this.sourceImgApps.activeRow.data;
      if( row.imap_appid == rmbxAppid.text )
      {
        let appname: string = row.imap_appname;
        appname = appname.replace( "&", "" );
        tbAppid.text = appname;
        break;
      }
    }
  }

  //Start of remote In/Out Box Access Logic
/** This is an event handler for the onRowDisplay event of tblUsers1. */
  tblUsers1OnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("tbDigroupType2") as Textbox;
    const type: string = txtbox.text
    //const tbGroupType = event.getTableRow().findComponentById("tbGroupType") as Textbox;
    if( type == "A" || type == "M" )
    {   //only show Desktop group
      event.getTableRow().visible = false;
    }

  }

/** This is an event handler for the onRowDisplay event of tbldidb. */
  tbldidbOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("tbDidbDesc2") as Textbox;
    let desc: string = txtbox.text
    desc = desc.replace( "&", "" );
    txtbox.text = desc;
  }

/** This is an event handler for the onSelect event of tblUsers1. */
  async tblUsers1OnSelect(event: TableSelectionEvent) {
    this.tbldidbOnSelect(event);
  }

/** This is an event handler for the onSelect event of tbldidb. */
  async tbldidbOnSelect(event: TableSelectionEvent) {
    if( this.tblUsers1.selectedRow != null && this.tbldidb.selectedRow != null )
    {
      const userrow: any = this.tblUsers1.selectedRow.data;
      const didbrow: any = this.tbldidb.selectedRow.data;
      const uid = userrow._data.diuser_uid;
      const dbid = didbrow._data.didb_dbalias;
      await this.sourceSecrembox.search( { srmbx_userid: uid, srmbx_dbalias: dbid } );
      await this.sourceDirembox.search( { rmbx_dba: dbid } );
    }
  }

/** This is an event handler for the onRowDisplay event of tblsecrembox. */
  async tblsecremboxOnRowDisplay(event: TableRowDisplayEvent) {
    const chkbox = event.getTableRow().findComponentById("cbRemBox") as Checkbox;
    chkbox.printable = false;

    //const txtbox = event.getTableRow().findComponentById("textboxSrmbxUserid") as Textbox;
    //const userid = txtbox.text;
    const userrow: any = this.tblUsers1.selectedRow.data;
    const uid = userrow._data.diuser_uid;

    //const tbdesc = event.getTableRow().findComponentById("tbRmbxDesc2") as Textbox;
    //const desc = tbdesc.text;
    const tbrid = event.getTableRow().findComponentById("tbRmbxId2") as Textbox;
    const rid = Number(tbrid.text);
    // const tbrd = event.getTableRow().findComponentById("textboxSrmbxRmbxid") as Textbox;
    // tbrd.setProps({ text: tbrid.text, color: "success" });

    let found = 0;
    for( let i = 0; i < this.sourceSecrembox.rowCount; i++ )
    {
      this.sourceSecrembox.rowIndex = i;
      const row: any = this.sourceSecrembox.activeRow.data;
      if( row.srmbx_rmbxid == rid && row.srmbx_userid == uid )
      {
        found = 1;
        break;
      }
    }
    if( found == 1 )
    {
      chkbox.checked = true;
      event.getTableRow().selected = true;
    }
    else
    {
      chkbox.checked = false;
      event.getTableRow().selected = false;
    }
  }


/** This is an event handler for the onClick event of cbRemBox. */
  async cbRemBoxOnClick(event: ClickEvent) {
    const userrow: any = this.tblUsers1.selectedRow.data;
    const uid = userrow._data.diuser_uid;
    const didbrow: any = this.tbldidb.selectedRow.data;
    const dbid = didbrow._data.didb_dbalias;

    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    const rid = row._data.rmbx_id;

    const prow: any = new ModelRow("imaging/AccessAdmin/secrembox", true);
    prow.set( "srmbx_userid", uid );
    prow.set( "srmbx_rmbxid", rid );
    prow.set( "srmbx_dbalias", dbid );
    if( !chkbox.checked )
    {   //add row
      prow.mode = DataSourceMode.ADD;
      this.sourceSecrembox.mode = DataSourceMode.ADD;
      this.sourceSecrembox.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceSecrembox.post();
    }
    else
    {   //delete row
      const resp = await this.sourceSecrembox.search( prow );
      if( resp != null && this.sourceSecrembox.rowCount == 1 )
      {
        this.sourceSecrembox.rowIndex = 0;
        const recid = this.sourceSecrembox.activeRow.data.srmbx_recid;
        prow.set( "srmbx_recid", recid );
        prow.mode = DataSourceMode.NONE;
        this.sourceSecrembox.mode = DataSourceMode.NONE;
        this.sourceSecrembox.setRowsAndMode( prow.mode, [prow], null );
        this.sourceSecrembox.delete();
      }
    }
  }

  //Start of eForms Templates Logic
/** This is an event handler for the onRowDisplay event of tblUsers2. */
  tblUsers2OnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("tbxDigroupType") as Textbox;
    const type: string = txtbox.text
    //const tbGroupType = event.getTableRow().findComponentById("tbGroupType") as Textbox;
    if( type == "A" || type == "M" )
    {   //only show Desktop group
      event.getTableRow().visible = false;
    }
  }

/** This is an event handler for the onRowDisplay event of tblDb2. */
  tblDb2OnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("tbxDidbDesc") as Textbox;
    let desc: string = txtbox.text
    desc = desc.replace( "&", "" );
    txtbox.text = desc;
  }

/** This is an event handler for the onSelect event of tblUsers2. */
  tblUsers2OnSelect(event: TableSelectionEvent) {
    this.tblDb2OnSelect(event);
  }

/** This is an event handler for the onSelect event of tblDb2. */
  async tblDb2OnSelect(event: TableSelectionEvent) {
    if( this.tblUsers2.selectedRow != null && this.tblDb2.selectedRow != null )
    {
      const userrow: any = this.tblUsers2.selectedRow.data;
      const didbrow: any = this.tblDb2.selectedRow.data;
      const uid = userrow._data.diuser_uid;
      const dbid = didbrow._data.didb_dbalias;
      await this.sourceSectmplt.search( { stmpl_userid: uid, stmpl_dbalias: dbid } );
      await this.sourceDstemplateh.search( { dsth_dbalias: dbid } );
    }
  }

/** This is an event handler for the onRowDisplay event of tbldstemplateh. */
  tbldstemplatehOnRowDisplay(event: TableRowDisplayEvent) {
    const chkbox = event.getTableRow().findComponentById("cbTempAcc") as Checkbox;
    chkbox.printable = false;

    //const txtbox = event.getTableRow().findComponentById("textboxSrmbxUserid") as Textbox;
    //const userid = txtbox.text;
    const userrow: any = this.tblUsers2.selectedRow.data;
    const uid = userrow._data.diuser_uid;

    //const tbdesc = event.getTableRow().findComponentById("tbRmbxDesc2") as Textbox;
    //const desc = tbdesc.text;
    const tbtid = event.getTableRow().findComponentById("textboxDsthTid") as Textbox;
    const tid = Number(tbtid.text);
    // const tbrd = event.getTableRow().findComponentById("textboxSrmbxRmbxid") as Textbox;
    // tbrd.setProps({ text: tbrid.text, color: "success" });

    let found = 0;
    for( let i = 0; i < this.sourceSectmplt.rowCount; i++ )
    {
      this.sourceSectmplt.rowIndex = i;
      const row: any = this.sourceSectmplt.activeRow.data;
      if( row.stmpl_tid == tid && row.stmpl_userid == uid )
      {
        found = 1;
        break;
      }
    }
    if( found == 1 )
    {
      chkbox.checked = true;
      event.getTableRow().selected = true;
    }
    else
    {
      chkbox.checked = false;
      event.getTableRow().selected = false;
    }
  }

/** This is an event handler for the onClick event of cbTempAcc. */
  async cbTempAccOnClick(event: ClickEvent) {
    const userrow: any = this.tblUsers2.selectedRow.data;
    const uid = userrow._data.diuser_uid;
    const didbrow: any = this.tblDb2.selectedRow.data;
    const dbid = didbrow._data.didb_dbalias;

    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    const tid = row._data.dsth_tid;

    const prow: any = new ModelRow("imaging/AccessAdmin/sectmplt", true);
    prow.set( "stmpl_userid", uid );
    prow.set( "stmpl_tid", tid );
    prow.set( "stmpl_dbalias", dbid );
    if( !chkbox.checked )
    {   //add row
      prow.mode = DataSourceMode.ADD;
      this.sourceSectmplt.mode = DataSourceMode.ADD;
      this.sourceSectmplt.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceSectmplt.post();
    }
    else
    {   //delete row
      const resp = await this.sourceSectmplt.search( prow );
      if( resp != null && this.sourceSectmplt.rowCount == 1 )
      {
        this.sourceSectmplt.rowIndex = 0;
        const recid = this.sourceSectmplt.activeRow.data.stmpl_recid;
        prow.set( "stmpl_recid", recid );
        prow.mode = DataSourceMode.NONE;
        this.sourceSectmplt.mode = DataSourceMode.NONE;
        this.sourceSectmplt.setRowsAndMode( prow.mode, [prow], null );
        this.sourceSectmplt.delete();
      }
    }
  }

  //Start of eForms Reports Logic
/** This is an event handler for the onRowDisplay event of tblUsers3. */
  tblUsers3OnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("tbxDigType") as Textbox;
    const type: string = txtbox.text
    //const tbGroupType = event.getTableRow().findComponentById("tbGroupType") as Textbox;
    if( type == "A" || type == "M" )
    {   //only show Desktop group
      event.getTableRow().visible = false;
    }
  }

/** This is an event handler for the onRowDisplay event of tblUsers4. */
  tblUsers4OnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDigroupType") as Textbox;
    const type: string = txtbox.text
    //const tbGroupType = event.getTableRow().findComponentById("tbGroupType") as Textbox;
    if( type == "A" || type == "M" )
    {   //only show Desktop group
      event.getTableRow().visible = false;
    }
    else
    {
      const chkbox = event.getTableRow().findComponentById("cbViewUser") as Checkbox;
      chkbox.printable = false;
    }
  }

/** This is an event handler for the onSelect event of tblUsers3. */
  async tblUsers3OnSelect(event: TableSelectionEvent) {
    if( this.tblUsers3.selectedRow != null )
    {
      const userrow: any = this.tblUsers3.selectedRow.data;
      const uid = userrow._data.diuser_uid;
      await this.sourceSecview.search( { secvw_uid: uid } );
      //update checkbox
      let vuid = -1;
      let chkbox = null;
      for( let r = 0; r < this.tblUsers4.rowCount; r++ )
      {
        const row: any = this.tblUsers4.getRowByIndex(r);
        chkbox = row.findComponentById("cbViewUser") as Checkbox;
        if( !chkbox )
          continue; //should not happen
        chkbox.printable = false;
        vuid = row._data._data.diuser_uid;
        let found = 0;
        for( let i = 0; i < this.sourceSecview.rowCount; i++ )
        {
          this.sourceSecview.rowIndex = i;
          const row: any = this.sourceSecview.activeRow.data;
          if( row.secvw_viewid == vuid && row.secvw_uid == uid )
          {
            found = 1;
            break;
          }
        }
        if( found == 1 )
        {
          chkbox.checked = true;
          row.selected = true;
        }
        else
        {
          chkbox.checked = false;
          row.selected = false;
        }
      }
      //    await this.sourceDiuser.search( );
    }
  }

/** This is an event handler for the onClick event of cbViewUser. */
  async cbViewUserOnClick(event: ClickEvent) {
    const userrow: any = this.tblUsers3.selectedRow.data;
    const uid = userrow._data.diuser_uid;
    //const didbrow: any = this.tblDb2.selectedRow.data;
    //const dbid = didbrow._data.didb_dbalias;

    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    const vid = row._data.diuser_uid;

    const prow: any = new ModelRow("imaging/AccessAdmin/secview", true);
    prow.set( "secvw_uid", uid );
    prow.set( "secvw_viewid", vid );
    //prow.set( "stmpl_dbalias", dbid );
    if( !chkbox.checked )
    {   //add row
      prow.mode = DataSourceMode.ADD;
      this.sourceSecview.mode = DataSourceMode.ADD;
      this.sourceSecview.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceSecview.post();
    }
    else
    {   //delete row
      const resp = await this.sourceSecview.search( prow );
      if( resp != null && this.sourceSecview.rowCount == 1 )
      {
        this.sourceSecview.rowIndex = 0;
        const recid = this.sourceSecview.activeRow.data.secvw_recid;
        prow.set( "secvw_recid", recid );
        prow.mode = DataSourceMode.NONE;
        this.sourceSecview.mode = DataSourceMode.NONE;
        this.sourceSecview.setRowsAndMode( prow.mode, [prow], null );
        this.sourceSecview.delete();
      }
    }
  }

  //Start of Dashboard Logic
/** This is an event handler for the onRowDisplay event of tblUsers5. */
  tblUsers5OnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDigroupType51") as Textbox;
    const type: string = txtbox.text
    //const tbGroupType = event.getTableRow().findComponentById("tbGroupType") as Textbox;
    if( type == "A" || type == "M" )
    {   //only show Desktop group
      event.getTableRow().visible = false;
    }
  }

/** This is an event handler for the onRowDisplay event of tblMonitors. */
  tblMonitorsOnRowDisplay(event: TableRowDisplayEvent) {
    const chkbUpdate = event.getTableRow().findComponentById("chkbUpdate") as Checkbox;
    chkbUpdate.printable = false;
    chkbUpdate.enabled = false;
    const chkbView = event.getTableRow().findComponentById("chkbView") as Checkbox;
    chkbView.printable = false;
    chkbView.enabled = false;
    const chkbCreateMonitors = this.pnl62.findComponentById("chkbCreateMonitors") as Checkbox;
    chkbCreateMonitors.checked = false;
    chkbCreateMonitors.enabled = false;
  }

/** This is an event handler for the onSelect event of tblUsers5. */
  async tblUsers5OnSelect(event: TableSelectionEvent) {
    if( this.tblUsers5.selectedRow != null )
    {
      const chkbCreateMonitors = this.pnl62.findComponentById("chkbCreateMonitors") as Checkbox;
      chkbCreateMonitors.checked = false;
      chkbCreateMonitors.enabled = true;
      const userrow: any = this.tblUsers5.selectedRow.data;
      const uid = userrow._data.diuser_uid;
      //await this.sourceDminfo.search( );
      await this.sourceDmsecurity.search( { dmsec_uid: uid } );
      for( let i = 0; i < this.sourceDmsecurity.rowCount; i++ )
      {
        this.sourceDmsecurity.rowIndex = i;
        const row: any = this.sourceDmsecurity.activeRow.data;
        if( row.dmsec_uid == uid && row.dmsec_access == "A," && row.dmsec_mid == 0 )
        {
          chkbCreateMonitors.checked = true;
          break;
        }
      }
      let chkbUpdate = null;
      let chkbView = null;
      for( let r = 0; r < this.tblMonitors.rowCount; r++ )
      {
        const row: any = this.tblMonitors.getRowByIndex(r);
        chkbUpdate = row.findComponentById("chkbUpdate") as Checkbox;
        chkbUpdate.checked = false;
        chkbUpdate.enabled = true;
        chkbView = row.findComponentById("chkbView") as Checkbox;
        chkbView.checked = false;
        chkbView.enabled = true;
        const mid: any = row._data._data.dmi_id;
        for( let i = 0; i < this.sourceDmsecurity.rowCount; i++ )
        {
          this.sourceDmsecurity.rowIndex = i;
          const row: any = this.sourceDmsecurity.activeRow.data;
          const access: String = row.dmsec_access;
          if( row.dmsec_uid == uid && access.includes( "V," ) && row.dmsec_mid == mid )
            chkbView.checked = true;
          if( row.dmsec_uid == uid && access.includes( "U," ) && row.dmsec_mid == mid )
            chkbUpdate.checked = true;
        }
      }
    }
  }


/** This is an event handler for the onClick event of chkbCreateMonitors. */
  async chkbCreateMonitorsOnClick(event: ClickEvent) {
    const userrow: any = this.tblUsers5.selectedRow.data;
    const uid = userrow._data.diuser_uid;

    const chkbox: any = event.target as Checkbox;
    const prow: any = new ModelRow("imaging/AccessAdmin/dmsecurity", true);
    prow.set( "dmsec_uid", uid );
    prow.set( "dmsec_mid", 0 );
    prow.set( "dmsec_access", "A," );
    if( chkbox.checked )
    {   //add row to create monitors
      prow.mode = DataSourceMode.ADD;
      this.sourceDmsecurity.mode = DataSourceMode.ADD;
      this.sourceDmsecurity.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDmsecurity.post();
    }
    else
    {   //delete row
      const resp = await this.sourceDmsecurity.search( prow );
      if( resp != null && this.sourceDmsecurity.rowCount == 1 )
      {
        this.sourceDmsecurity.rowIndex = 0;
        const recid = this.sourceDmsecurity.activeRow.data.dmsec_recid;
        prow.set( "dmsec_recid", recid );
        prow.mode = DataSourceMode.NONE;
        this.sourceDmsecurity.mode = DataSourceMode.NONE;
        this.sourceDmsecurity.setRowsAndMode( prow.mode, [prow], null );
        this.sourceDmsecurity.delete();
      }
    }
  }

/** This is an event handler for the onClick event of chkbUpdate. */
  async chkbUpdateOnClick(event: ClickEvent) {
    const userrow: any = this.tblUsers5.selectedRow.data;
    const uid = userrow._data.diuser_uid;

    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    const mid = row._data.dmi_id;

    const prow: any = new ModelRow("imaging/AccessAdmin/dmsecurity", true);
    prow.set( "dmsec_uid", uid );
    prow.set( "dmsec_mid", mid );
    const resp = await this.sourceDmsecurity.search( prow );
    let access: String = "";
    let recid = -1;
    if( resp == null || this.sourceDmsecurity.rowCount == 0 )
    {
      access = "U,";
      prow.set( "dmsec_access", access );
      prow.mode = DataSourceMode.ADD;
      this.sourceDmsecurity.mode = DataSourceMode.ADD;
      this.sourceDmsecurity.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDmsecurity.post();
    }
    else if( resp != null && this.sourceDmsecurity.rowCount == 1 )
    {
      this.sourceDmsecurity.rowIndex = 0;
      recid = this.sourceDmsecurity.activeRow.data.dmsec_recid;
      access = this.sourceDmsecurity.activeRow.data.dmsec_access;
      //delete current row
      prow.set( "dmsec_recid", recid );
      prow.mode = DataSourceMode.NONE;
      this.sourceDmsecurity.mode = DataSourceMode.NONE;
      this.sourceDmsecurity.setRowsAndMode( prow.mode, [prow], null );
      this.sourceDmsecurity.delete();
      do{
        const resp = await this.sourceDmsecurity.search( prow );
      }while( this.sourceDmsecurity.rowCount > 0 );

      //add new row if necessary
      if( chkbox.checked )
      {   //update row
        if( !access.includes( "U," ) )
        { //add U value to current row
          access += "U,";
          prow.set( "dmsec_access", access );
          prow.set( "dmsec_recid", "" );
          prow.mode = DataSourceMode.ADD;
          this.sourceDmsecurity.mode = DataSourceMode.ADD;
          this.sourceDmsecurity.setRowsAndMode( prow.mode, [prow], null );
          await this.sourceDmsecurity.post();
        }
      }
      else
      {
        if( access.includes( "U," ) && access.includes( "V," ) )
        { //delete U value from current row, keep V value
          access = "V,";
          prow.set( "dmsec_access", access );
          prow.set( "dmsec_recid", "" );
          prow.mode = DataSourceMode.ADD;
          this.sourceDmsecurity.mode = DataSourceMode.ADD;
          this.sourceDmsecurity.setRowsAndMode( prow.mode, [prow], null );
          await this.sourceDmsecurity.post();
        }
      }
    }
  }

/** This is an event handler for the onClick event of chkbView. */
  async chkbViewOnClick(event: ClickEvent) {
    const userrow: any = this.tblUsers5.selectedRow.data;
    const uid = userrow._data.diuser_uid;

    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    const mid = row._data.dmi_id;

    const prow: any = new ModelRow("imaging/AccessAdmin/dmsecurity", true);
    prow.set( "dmsec_uid", uid );
    prow.set( "dmsec_mid", mid );
    const resp = await this.sourceDmsecurity.search( prow );
    let access: String = "";
    let recid = -1;
    if( resp == null || this.sourceDmsecurity.rowCount == 0 )
    {   //Add V Value
      access = "V,";
      prow.set( "dmsec_access", access );
      prow.mode = DataSourceMode.ADD;
      this.sourceDmsecurity.mode = DataSourceMode.ADD;
      this.sourceDmsecurity.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDmsecurity.post();
    }
    else if( resp != null && this.sourceDmsecurity.rowCount == 1 )
    {
      this.sourceDmsecurity.rowIndex = 0;
      recid = this.sourceDmsecurity.activeRow.data.dmsec_recid;
      access = this.sourceDmsecurity.activeRow.data.dmsec_access;
      //delete current row
      prow.set( "dmsec_recid", recid );
      prow.mode = DataSourceMode.NONE;
      this.sourceDmsecurity.mode = DataSourceMode.NONE;
      this.sourceDmsecurity.setRowsAndMode( prow.mode, [prow], null );
      this.sourceDmsecurity.delete();
      do{
        const resp = await this.sourceDmsecurity.search( prow );
      }while( this.sourceDmsecurity.rowCount > 0 );

      //add new row if necessary
      if( chkbox.checked )
      {   //update row
        if( !access.includes( "V," ) )
        { //add V value to current row
          access += "V,";
          prow.set( "dmsec_access", access );
          prow.set( "dmsec_recid", "" );
          prow.mode = DataSourceMode.ADD;
          this.sourceDmsecurity.mode = DataSourceMode.ADD;
          this.sourceDmsecurity.setRowsAndMode( prow.mode, [prow], null );
          await this.sourceDmsecurity.post();
        }
      }
      else
      {
        if( access.includes( "U," ) && access.includes( "V," ) )
        { //delete V value from current row, keep U value
          access = "U,";
          prow.set( "dmsec_access", access );
          prow.set( "dmsec_recid", "" );
          prow.mode = DataSourceMode.ADD;
          this.sourceDmsecurity.mode = DataSourceMode.ADD;
          this.sourceDmsecurity.setRowsAndMode( prow.mode, [prow], null );
          await this.sourceDmsecurity.post();
        }
      }
    }
  }

  //Start of Rendition Access Logic
/** This is an event handler for the onRowDisplay event of tblUsers7. */
  tblUsers7OnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDigroupType71") as Textbox;
    const type: string = txtbox.text
    //const tbGroupType = event.getTableRow().findComponentById("tbGroupType") as Textbox;
    if( type == "A" || type == "M" )
    {   //only show Desktop group
      event.getTableRow().visible = false;
    }
  }

/** This is an event handler for the onRowDisplay event of tblDb8. */
  tblDb8OnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDidbDesc81") as Textbox;
    let desc: string = txtbox.text
    desc = desc.replace( "&", "" );
    txtbox.text = desc;
  }

/** This is an event handler for the onRowDisplay event of tblRenAccType9. */
  tblRenAccType9OnRowDisplay(event: TableRowDisplayEvent) {
    const chkbox = event.getTableRow().findComponentById("chkbType91") as Checkbox;
    chkbox.printable = false;
    chkbox.checked = false;
    chkbox.enabled = false;
    const txtbox = event.getTableRow().findComponentById("textboxLvTable91") as Textbox;
    const table: string = txtbox.text
    const txtbox2 = event.getTableRow().findComponentById("textboxLvValue91") as Textbox;
    const value: string = txtbox2.text

    //const tbGroupType = event.getTableRow().findComponentById("tbGroupType") as Textbox;
    if( table != "direnaccess" )
    {   //only show Desktop group
      event.getTableRow().visible = false;
    }
    else
    {
      if( this.tblUsers7.selectedRow != null && this.tblDb8.selectedRow != null )
      {
        chkbox.enabled = true;
        const userrow: any = this.tblUsers7.selectedRow.data;
        const didbrow: any = this.tblDb8.selectedRow.data;
        const uid = userrow._data.diuser_uid;
        const dbid = didbrow._data.didb_dbalias;
        for( let i: any = 0; i < this.sourceDirenaccess.rowCount; i++ )
        {
          this.sourceDirenaccess.rowIndex = i;
          const row: any = this.sourceDirenaccess.activeRow.data;
          const access: String = row.renacc_access;
          if( row.renacc_uid == uid && access == value )
          {
            chkbox.checked = true;
          }
        }
      }
    }
  }

/** This is an event handler for the onSelect event of tblUsers7. */
  tblUsers7OnSelect(event: TableSelectionEvent) {
    this.tblDb8OnSelect(event);
  }

/** This is an event handler for the onSelect event of tblDb8. */
  async tblDb8OnSelect(event: TableSelectionEvent) {
    if( this.tblUsers7.selectedRow != null && this.tblDb8.selectedRow != null )
    {
      const userrow: any = this.tblUsers7.selectedRow.data;
      const didbrow: any = this.tblDb8.selectedRow.data;
      const uid = userrow._data.diuser_uid;
      const dbid = didbrow._data.didb_dbalias;
      await this.sourceDirenaccess.search( { renacc_uid: uid, renacc_dbalias: dbid } );
      await this.sourceImglistvalues.search( { lv_table: "direnaccess", lv_value: "<>FX" } );
    }
  }

/** This is an event handler for the onClick event of chkbType91. */
  async chkbType91OnClick(event: ClickEvent) {
    const userrow: any = this.tblUsers7.selectedRow.data;
    const didbrow: any = this.tblDb8.selectedRow.data;
    const uid = userrow._data.diuser_uid;
    const dbid = didbrow._data.didb_dbalias;

    const chkbox: any = event.target as Checkbox;
    const acctype = chkbox.row.data;
    const access = acctype._data.lv_value;

    const prow: any = new ModelRow("imaging/AccessAdmin/direnaccess", true);
    prow.set( "renacc_uid", uid );
    prow.set( "renacc_access", access );
    prow.set( "renacc_dbalias", dbid );
    const resp = await this.sourceDirenaccess.search( prow );
    if( chkbox.checked || this.sourceDirenaccess.rowCount == 0 )
    {   //add row to create monitors
      prow.mode = DataSourceMode.ADD;
      this.sourceDirenaccess.mode = DataSourceMode.ADD;
      this.sourceDirenaccess.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDirenaccess.post();
    }
    else
    {   //delete row
      if( resp != null && this.sourceDirenaccess.rowCount == 1 )
      {
        this.sourceDirenaccess.rowIndex = 0;
        const recid = this.sourceDirenaccess.activeRow.data.renacc_recid;
        prow.set( "renacc_recid", recid );
        prow.mode = DataSourceMode.NONE;
        this.sourceDirenaccess.mode = DataSourceMode.NONE;
        this.sourceDirenaccess.setRowsAndMode( prow.mode, [prow], null );
        this.sourceDirenaccess.delete();
      }
    }
  }

  //Start of Solution Access Logic
/** This is an event handler for the onRowDisplay event of tblUsersSA. */
  tblUsersSAOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDigroupTypeSA") as Textbox;
    const type: string = txtbox.text
    //const tbGroupType = event.getTableRow().findComponentById("tbGroupType") as Textbox;
    if( type == "A" || type == "M" )
    {   //only show Desktop group
      event.getTableRow().visible = false;
    }
  }

/** This is an event handler for the onRowDisplay event of tblDbSA. */
  tblDbSAOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDidbDescSA") as Textbox;
    let desc: string = txtbox.text
    desc = desc.replace( "&", "" );
    txtbox.text = desc;
  }

/** This is an event handler for the onSelect event of tblUsersSA. */
  tblUsersSAOnSelect(event: TableSelectionEvent) {
    this.tblDbSAOnSelect( event );
  }

/** This is an event handler for the onSelect event of tblDbSA. */
  async tblDbSAOnSelect(event: TableSelectionEvent) {
    if( this.tblUsersSA.selectedRow != null && this.tblDbSA.selectedRow != null )
    {
      const userrow: any = this.tblUsersSA.selectedRow.data;
      const didbrow: any = this.tblDbSA.selectedRow.data;
      const uid = userrow._data.diuser_uid;
      const dbid = didbrow._data.didb_dbalias;
      await this.sourceDxaccgrp.search( { dxacr_grpid: ">0", dxacr_dbalias: dbid } );
    }
    this.tblAPSA.clearRows();
    this.tblATSA.clearRows();
  }

/** This is an event handler for the onSelect event of tblSolSA. */
  async tblSolSAOnSelect(event: TableSelectionEvent) {
    if( this.tblUsersSA.selectedRow != null && this.tblDbSA.selectedRow != null && this.tblSolSA.selectedRow != null )
    {
      const userrow: any = this.tblUsersSA.selectedRow.data;
      const didbrow: any = this.tblDbSA.selectedRow.data;
      const solrow: any = this.tblSolSA.selectedRow.data;
      const uid = userrow._data.diuser_uid;
      const dbid = didbrow._data.didb_dbalias;
      const solname = solrow._data.dxacr_name;
      const solgrp = solrow._data.dxacr_grpid;
      //await this.sourceDxaccgrnt.search( { dxacg_name: solname, dxacg_dbalias: dbid })
      await this.sourceDxaccessd.search( { dxacd_name: solname, dxacd_uid: uid, dxacd_dbalias: dbid } );
      await this.sourceDxaccessh.search( { dxach_name: solname, dxach_grpid: solgrp, dxach_dbalias: dbid } );
    }
  }

/** This is an event handler for the onRowDisplay event of tblAPSA. */
  async tblAPSAOnRowDisplay(event: TableRowDisplayEvent) {
    const chkbox = event.getTableRow().findComponentById("checkboxAPSA") as Checkbox;
    chkbox.printable = false;
    chkbox.checked = false;
    chkbox.displayLabel = "None";
    const txtbox = event.getTableRow().findComponentById("textboxDxachAccpnt") as Textbox;
    const raccpnt: string = txtbox.text
    //const didbrow: any = this.tblDbSA.selectedRow.data;
    //const dbid = didbrow._data.didb_dbalias;

    for( let i: any = 0; i < this.sourceDxaccessd.rowCount; i++ )
    {
      this.sourceDxaccessd.rowIndex = i;
      const row: any = this.sourceDxaccessd.activeRow.data;
      const accpnt: string = row.dxacd_accpnt;
      const grant: String = row.dxacd_grant;
      const sgrant: string = row.dxacd_grant;
      const name: string = row.dxacd_name;
      if( raccpnt == accpnt )
      {
        if( grant )
          chkbox.displayLabel = sgrant;
        chkbox.checked = true;
      }
    }
  }

/** This is an event handler for the onSelect event of tblAPSA. */
  async tblAPSAOnSelect(event: TableSelectionEvent) {
    if( this.tblAPSA.selectedRow != null )
    {
      const userrow: any = this.tblUsersSA.selectedRow.data;
      const didbrow: any = this.tblDbSA.selectedRow.data;
      const aprow: any = this.tblAPSA.selectedRow.data;
      const uid = userrow._data.diuser_uid;
      const dbid = didbrow._data.didb_dbalias;
      const name = aprow._data.dxach_name;
      const accpnt = aprow._data.dxach_accpnt;
      await this.sourceDxaccgrnt.search( { dxacg_name: name, dxacg_accpnt: accpnt, dxacg_dbalias: dbid } )
    }
  }

/** This is an event handler for the onRowDisplay event of tblATSA. */
  tblATSAOnRowDisplay(event: TableRowDisplayEvent) {
    const chkbox = event.getTableRow().findComponentById("checkboxATSA") as Checkbox;
    chkbox.printable = false;
    chkbox.checked = false;
    const userrow: any = this.tblUsersSA.selectedRow.data;
    const didbrow: any = this.tblDbSA.selectedRow.data;
    const aprow: any = this.tblAPSA.selectedRow.data;
    const uid = userrow._data.diuser_uid;
    const dbid = didbrow._data.didb_dbalias;
    const name = aprow._data.dxach_name;
    const accpnt = aprow._data.dxach_accpnt;
    const txtbox = event.getTableRow().findComponentById("textboxDxacgVal") as Textbox;
    let grant: string = txtbox.text
    const chkbap = this.tblAPSA.selectedRow.findComponentById("checkboxAPSA") as Checkbox;
    const ngrant: string = chkbap.displayLabel;
    grant += ",";
    if( ngrant && ngrant.includes( grant ) )
    {
      chkbox.checked = true;
    }
  }

/** This is an event handler for the onClick event of checkboxAPSA. */
  async checkboxAPSAOnClick(event: ClickEvent) {
    const userrow: any = this.tblUsersSA.selectedRow.data;
    const didbrow: any = this.tblDbSA.selectedRow.data;
    const uid = userrow._data.diuser_uid;
    const dbid = didbrow._data.didb_dbalias;

    const chkbox: any = event.target as Checkbox;
    const aprow = chkbox.row.data;
    const accpnt = aprow._data.dxach_accpnt
    const name = aprow._data.dxach_name;

    const prow: any = new ModelRow("imaging/AccessAdmin/dxaccessd", true);
    prow.set( "dxacd_name", name );
    prow.set( "dxacd_accpnt", accpnt );
    prow.set( "dxacd_uid", uid );
    prow.set( "dxacd_dbalias", dbid );
    const resp = await this.sourceDxaccessd.search( prow );
    if( chkbox.checked || this.sourceDxaccessd.rowCount == 0 )
    {   //add row to Access Point
      prow.set( "dxacd_grant", "" );
      prow.mode = DataSourceMode.ADD;
      this.sourceDxaccessd.mode = DataSourceMode.ADD;
      this.sourceDxaccessd.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDxaccessd.post();
    }
    else
    {   //delete row from Access Point
      if( resp != null && this.sourceDxaccessd.rowCount == 1 )
      {
        this.sourceDxaccessd.rowIndex = 0;
        const recid = this.sourceDxaccessd.activeRow.data.dxacd_recid;
        prow.set( "dxacd_recid", recid );
        prow.mode = DataSourceMode.NONE;
        this.sourceDxaccessd.mode = DataSourceMode.NONE;
        this.sourceDxaccessd.setRowsAndMode( prow.mode, [prow], null );
        this.sourceDxaccessd.delete();
      }
    }
  }

/** This is an event handler for the onClick event of checkboxATSA. */
  async checkboxATSAOnClick(event: ClickEvent) {
    const userrow: any = this.tblUsersSA.selectedRow.data;
    const didbrow: any = this.tblDbSA.selectedRow.data;
    const uid = userrow._data.diuser_uid;
    const dbid = didbrow._data.didb_dbalias;

    const chkbox: any = event.target as Checkbox;
    const atrow = chkbox.row.data;
    let val = atrow._data.dxacg_val

    const aprow: any = this.tblAPSA.selectedRow.data;
    const accpnt = aprow._data.dxach_accpnt;
    const name = aprow._data.dxach_name;

    let prow: any = new ModelRow("imaging/AccessAdmin/dxaccessd", true);
    prow.set( "dxacd_name", name );
    prow.set( "dxacd_accpnt", accpnt );
    prow.set( "dxacd_uid", uid );
    prow.set( "dxacd_dbalias", dbid );
    const resp = await this.sourceDxaccessd.search( prow );
    if( this.sourceDxaccessd.rowCount == 1 )
    {   //update row to Access Type
      this.sourceDxaccessd.rowIndex = 0;
      let grant: String = this.sourceDxaccessd.activeRow.data.dxacd_grant;
      const recid = this.sourceDxaccessd.activeRow.data.dxacd_recid;
      val += ",";
      if( chkbox.checked )
      {
        if( grant && !grant.includes(val) )
          grant += val;
        else
          grant = val;
      }
      else if( grant )
      {
        if( grant.includes(val) )
          grant = grant.replace( val, "" );
        else
          return;
      }
      else
        grant = "";
      prow.set( "dxacd_grant", grant );
      prow.set( "dxacd_recid", recid );
      prow.mode = DataSourceMode.UPDATE;
      this.sourceDxaccessd.mode = DataSourceMode.UPDATE;
      this.sourceDxaccessd.setRowsAndMode( prow.mode, [prow], null );
      prow = await this.sourceDxaccessd.post();
      if( prow )
      { //on success update displayLabel to reflect right status
        const chkbap = this.tblAPSA.selectedRow.findComponentById("checkboxAPSA") as Checkbox;
        const sgrant: any = grant;
        chkbap.displayLabel = sgrant;
      }
    }
  }

  //Start of REST API Access Logic
/** This is an event handler for the onRowDisplay event of tblUsersRA. */
  tblUsersRAOnRowDisplay(event: TableRowDisplayEvent) {
    event.getTableRow().visible = false;
    const txtbox = event.getTableRow().findComponentById("textboxDigroupTypeRA") as Textbox;
    const type: string = txtbox.text
    //const tbGroupType = event.getTableRow().findComponentById("tbGroupType") as Textbox;
    if( type == "A" )
    {   //only show Mobile group
      event.getTableRow().visible = true;
    }
  }

/** This is an event handler for the onRowDisplay event of tblDbRA. */
  tblDbRAOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDidbDescRA") as Textbox;
    let desc: string = txtbox.text
    desc = desc.replace( "&", "" );
    txtbox.text = desc;
  }

/** This is an event handler for the onSelect event of tblUsersRA. */
  tblUsersRAOnSelect(event: TableSelectionEvent) {
    this.tblDbRAOnSelect( event );
  }

/** This is an event handler for the onSelect event of tblDbRA. */
  async tblDbRAOnSelect(event: TableSelectionEvent) {
    if( this.tblUsersRA.selectedRow != null && this.tblDbRA.selectedRow != null )
    {
      this.tblProjectsRA.clearRows();
      const userrow: any = this.tblUsersRA.selectedRow.data;
      const didbrow: any = this.tblDbRA.selectedRow.data;
      const uid = userrow._data.diuser_uid;
      const dbid = didbrow._data.didb_dbalias;
      await this.sourceDxproject.search( { dxp_proj_id: ">0", dxp_status: "A", dxp_dbalias: dbid } );
    }
  }

/** This is an event handler for the onSelect event of tblProjectsRA. */
async tblProjectsRAOnSelect(event: TableSelectionEvent) {
  if( this.tblUsersRA.selectedRow != null && this.tblDbRA.selectedRow != null && this.tblProjectsRA != null )
  {
    this.tblApiFuncsRA.clearRows();
    const userrow: any = this.tblUsersRA.selectedRow.data;
    const didbrow: any = this.tblDbRA.selectedRow.data;
    const uid = userrow._data.diuser_uid;
    const dbid = didbrow._data.didb_dbalias;
    if( this.tblProjectsRA.selectedRow )
    {
      const tblrow: any = this.tblProjectsRA.selectedRow.data;
      const projid = tblrow._data.dxp_proj_id;
      const mid = tblrow._data.dxp_master_id;
      await this.sourceDiwapisec.search( { diw_proj_id: projid, diw_master_id: mid, diw_uid: uid, diw_dbalias: dbid } );
      await this.sourceDxfunction.search( { dxf_proj_id: projid, dxf_name: "api_%", dxf_dbalias: dbid } );
    }
  }
}

/** This is an event handler for the onRowDisplay event of tblApiFuncsRA. */
  async tblApiFuncsRAOnRowDisplay(event: TableRowDisplayEvent) {
    const userrow: any = this.tblUsersRA.selectedRow.data;
    const didbrow: any = this.tblDbRA.selectedRow.data;
    const uid = userrow._data.diuser_uid;
    const dbid = didbrow._data.didb_dbalias;
    const tblrow: any = this.tblProjectsRA.selectedRow.data;
    const projid = tblrow._data.dxp_proj_id;
    const mid = tblrow._data.dxp_master_id;

    const trow = event.getTableRow();
    const chkbox = trow.findComponentById("cbAPIFunction") as Checkbox;
    chkbox.printable = false;
    chkbox.checked = false;
    const txtbox = trow.findComponentById("textboxDxfFuncIdRA") as Textbox;
    const funcid = txtbox.text;

    for( let i: any = 0; i < this.sourceDiwapisec.rowCount; i++ )
    {
      this.sourceDiwapisec.rowIndex = i;
      const row: any = this.sourceDiwapisec.activeRow.data;
      const fid: String = row.diw_func_id;
      const mpid: any = row.diw_master_id;
      if( mpid == mid && fid == funcid )
      {
        chkbox.checked = true;
        break;
      }
    }
  }


/** This is an event handler for the onClick event of cbAPIFunction. */
  async cbAPIFunctionOnClick(event: ClickEvent) {
    const userrow: any = this.tblUsersRA.selectedRow.data;
    const didbrow: any = this.tblDbRA.selectedRow.data;
    const uid = userrow._data.diuser_uid;
    const dbid = didbrow._data.didb_dbalias;

    const tblrow: any = this.tblProjectsRA.selectedRow.data;
    const projid = tblrow._data.dxp_proj_id;
    const mid = tblrow._data.dxp_master_id;
    const appname = tblrow._data.dxp_revision;

    const chkbox: any = event.target as Checkbox;
    const apifrow = chkbox.row.data;
    const funcid = apifrow._data.dxf_func_id;
    const fname = apifrow._data.dxf_name;

    const prow: any = new ModelRow("imaging/AccessAdmin/diwapisec", true);
    //prow.set( "diw_func_name", fname );
    const ldate: any = new Date();
    const ltime: any = ldate.getHours()*60 + ldate.getMinutes();
    const tbExpDate = this.pnlProjectsRA.findComponentById( "textboxDiwExpdate") as Textbox;
    const cbStatus = this.pnlProjectsRA.findComponentById( "chkbxStatus") as Checkbox;
    const status = cbStatus.checked ? cbStatus.valueChecked : cbStatus.valueUnchecked;
    const cbNoexp = this.pnlProjectsRA.findComponentById( "chkbxNoDateExp") as Checkbox;
    const noexp = cbNoexp.checked ? cbNoexp.valueChecked : cbNoexp.valueUnchecked;
    let expdate = ldate;
    if( tbExpDate.text )
      expdate = new Date(tbExpDate.text);
    prow.set( "diw_uid", uid );
    prow.set( "diw_app_name", appname );
    prow.set( "diw_master_id", mid );
    prow.set( "diw_func_id", funcid );
    prow.set( "diw_dbalias", dbid );
    const resp = await this.sourceDiwapisec.search( prow );
    if( chkbox.checked || this.sourceDiwapisec.rowCount == 0 )
    {   //add row to API Functions Security
      prow.set( "diw_expdate", expdate );
      prow.set( "diw_lstdt", ldate );
      prow.set( "diw_lsttm", ltime );
      prow.set( "diw_status", status );
      prow.set( "diw_noexp", noexp );
      prow.mode = DataSourceMode.ADD;
      this.sourceDiwapisec.mode = DataSourceMode.ADD;
      this.sourceDiwapisec.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDiwapisec.post();
    }
    else
    {   //delete row API Functions Security
      if( resp != null && this.sourceDiwapisec.rowCount == 1 )
      {
        this.sourceDiwapisec.rowIndex = 0;
        const recid = this.sourceDiwapisec.activeRow.data.diw_recid;
        prow.set( "diw_recid", recid );
        prow.mode = DataSourceMode.NONE;
        this.sourceDiwapisec.mode = DataSourceMode.NONE;
        this.sourceDiwapisec.setRowsAndMode( prow.mode, [prow], null );
        this.sourceDiwapisec.delete();
      }
    }
  }

/** This is an event handler for the onClick event of chkbxStatus. */
  async chkbxStatusOnClick(event: ClickEvent) {
    if( this.tblApiFuncsRA.selectedRow != null )
    {
      const userrow: any = this.tblUsersRA.selectedRow.data;
      const didbrow: any = this.tblDbRA.selectedRow.data;
      const uid = userrow._data.diuser_uid;
      const dbid = didbrow._data.didb_dbalias;

      const tblrow: any = this.tblProjectsRA.selectedRow.data;
      const projid = tblrow._data.dxp_proj_id;
      const mid = tblrow._data.dxp_master_id;
      const appname = tblrow._data.dxp_revision;

      const frow: any = this.tblApiFuncsRA.selectedRow.data;
      const funcid = frow._data.dxf_func_id;
      //const chkbox: any = event.target as Checkbox;

      const prow: any = new ModelRow("imaging/AccessAdmin/diwapisec", true);
      //prow.set( "diw_func_name", fname );
      const ldate: any = new Date();
      const ltime: any = ldate.getHours()*60 + ldate.getMinutes();
      const tbExpDate = this.pnlProjectsRA.findComponentById( "textboxDiwExpdate") as Textbox;
      const cbStatus = this.pnlProjectsRA.findComponentById( "chkbxStatus") as Checkbox;
      const status = cbStatus.checked ? cbStatus.valueChecked : cbStatus.valueUnchecked;
      const cbNoexp = this.pnlProjectsRA.findComponentById( "chkbxNoDateExp") as Checkbox;
      const noexp = cbNoexp.checked ? cbNoexp.valueChecked : cbNoexp.valueUnchecked;
      let expdate = ldate;
      if( tbExpDate.text )
        expdate = new Date(tbExpDate.text);
      prow.set( "diw_uid", uid );
      prow.set( "diw_app_name", appname );
      prow.set( "diw_master_id", mid );
      prow.set( "diw_func_id", funcid );
      prow.set( "diw_dbalias", dbid );
      const resp = await this.sourceDiwapisec.search( prow );
      if( resp != null && this.sourceDiwapisec.rowCount == 1 )
      {   //update row API Functions Security
        const recid = this.sourceDiwapisec.activeRow.data.diw_recid;
        prow.set( "diw_expdate", expdate );
        prow.set( "diw_lstdt", ldate );
        prow.set( "diw_lsttm", ltime );
        prow.set( "diw_status", status );
        prow.set( "diw_noexp", noexp );
        prow.set( "diw_recid", recid );
        prow.mode = DataSourceMode.ADD;
        this.sourceDiwapisec.mode = DataSourceMode.ADD;
        this.sourceDiwapisec.setRowsAndMode( prow.mode, [prow], null );
        await this.sourceDiwapisec.post();
      }
    }
  }

/** This is an event handler for the onClick event of chkbxNoDateExp. */
  chkbxNoDateExpOnClick(event: ClickEvent) {
    this.chkbxStatusOnClick( event );
  }


/** This is an event handler for the onClick event of pbDisplayApiKey. */
  async pbDisplayApiKeyOnClick(event: ClickEvent) {
    const userrow: any = this.tblUsersRA.selectedRow.data;
    const uid: any = userrow._data.diuser_uid;
    let dbaliases: any = "";
    for( let i: any = 0; i < this.tblDbRA.rowCount; i++ )
    {   //get all dbs
      const didbrow: any = this.tblDbRA.getRowByIndex( i ).data;
      const dbid: any = didbrow._data.didb_dbalias;
      const instance: any = didbrow._data.didb_instance;
      dbaliases += dbid +  "|";
    }
    // Get API Key
    try {
      await Api.post("register-admin/nagent", {action: "encrypt",
                      service_name: dbaliases, host_name: uid,
                      ip_address: "diwapisec", port: "-1" }).then(response => {
      if( response )
      {
        let es: any = response.data[0].servicename;
        es = es.replace( "0:", "" );
        es = es.replace( "1:", "" );
        es = es.replace( ",,;", "" );
        const panel = new Panel();
        const label = new Label({ text: es, fontBold: true });
        label.wrap = true;
        panel.wrap = true;
        panel.add(label);
        CommonDialogs.showMessage( panel, "API Key", { resizable: true, movable: true } );
        //CommonDialogs.showMessage( es, "API Key", { width: "80%", height: "80%", resizable: true, movable: true });
        //console.log( response );
        //console.log( response.data[0].servicename );
      }
      else
        CommonDialogs.showMessage("Failed creating key for user[" + uid + "]", "Document Power", { resizable: true, movable: true });
    });
    } finally {

    }
  }

  //Start of Web Module Access Logic
/** This is an event handler for the onRowDisplay event of tblUsersRA. */
tblGroupsWMAOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDigroupTypeWMA") as Textbox;
    let type: string = txtbox.text
    const tbGroupType = event.getTableRow().findComponentById("tbDigroupTypeWMA") as Textbox;
    let desc=null;
    if( type == "A" )
    {
      desc = "API";
      event.getTableRow().visible = false;
    }
    else if( type == "M" )
      desc = "Mobile";
    else //if( type == "D" )
    {
      desc = "Desktop";
      type = "D";
    }
    //tbGroupType.setProps({ text: desc, color: "success" });
    tbGroupType.text = desc;
  }

/** This is an event handler for the onRowDisplay event of tblDbRA. */
tblDbsWMAOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDidbDescWMA") as Textbox;
    let desc: string = txtbox.text
    desc = desc.replace( "&", "" );
    txtbox.text = desc;
  }

/** This is an event handler for the onSelect event of tblGroupsWMA. */
  tblGroupsWMAOnSelect(event: TableSelectionEvent) {
    this.tblDbsWMAOnSelect( event );
  }

/** This is an event handler for the onSelect event of tblDbsWMA. */
  async tblDbsWMAOnSelect(event: TableSelectionEvent) {
    if( this.tblGroupsWMA.selectedRow != null && this.tblDbsWMA.selectedRow != null )
    {
      this.tblWebModulesWMA.clearRows();
      const grouprow: any = this.tblGroupsWMA.selectedRow.data;
      const didbrow: any = this.tblDbsWMA.selectedRow.data;
      const gid = grouprow._data.digroup_gid;
      const dbid = didbrow._data.didb_dbalias;
      await this.sourceDiwmodsec.search( { diwms_dba: dbid, diwms_gid: gid } );
      await this.sourceDxproject.search( { dxp_secured: "Y", dxp_dbalias: dbid } );
    }
  }

/** This is an event handler for the onRowDisplay event of tblWebModulesWMA. */
  tblWebModulesWMAOnRowDisplay(event: TableRowDisplayEvent) {
    if( this.tblGroupsWMA.selectedRow != null && this.tblDbsWMA.selectedRow != null )
    {
      const trow = event.getTableRow();
      const chkbox = trow.findComponentById("cbWebModule") as Checkbox;
      chkbox.printable = false;
      chkbox.checked = false;
      const txtbox = trow.findComponentById("textboxDxpMasterIdWMA") as Textbox;
      let mpid = trow.data._data.dxp_master_id;
      mpid = txtbox.text;
      const grouprow: any = this.tblGroupsWMA.selectedRow.data;
      const didbrow: any = this.tblDbsWMA.selectedRow.data;
      const gid = grouprow._data.digroup_gid;
      const dbid = didbrow._data.didb_dbalias;
      for( let i: any = 0; i < this.sourceDiwmodsec.rowCount; i++ )
      {
        this.sourceDiwmodsec.rowIndex = i;
        const row: any = this.sourceDiwmodsec.activeRow.data;
        const wmgid: any = row.diwms_gid;
        const wmpid: any = row.diwms_mpid;
        if( mpid == wmpid )
        {
          chkbox.checked = true;
          break;
        }
      }
    }
  }

/** This is an event handler for the onClick event of cbWebModule. */
  async cbWebModuleOnClick(event: ClickEvent) {
    const grouprow: any = this.tblGroupsWMA.selectedRow.data;
    const didbrow: any = this.tblDbsWMA.selectedRow.data;
    const gid = grouprow._data.digroup_gid;
    const dbid = didbrow._data.didb_dbalias;

    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    const mid = row._data.dxp_master_id;
    const appname = row._data.dxp_revision;

    const prow: any = new ModelRow("imaging/AccessAdmin/diwmodsec", true);
    prow.set( "diwms_dba", dbid );
    prow.set( "diwms_mpid", mid );
    prow.set( "diwms_gid", gid );
    const resp = await this.sourceDiwmodsec.search( prow );
    if( chkbox.checked || this.sourceDiwmodsec.rowCount == 0 )
    {   //add row to API Functions Security
      prow.mode = DataSourceMode.ADD;
      this.sourceDiwmodsec.mode = DataSourceMode.ADD;
      this.sourceDiwmodsec.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDiwmodsec.post();
    }
    else
    {   //delete row API Functions Security
      if( resp != null && this.sourceDiwmodsec.rowCount == 1 )
      {
        this.sourceDiwmodsec.rowIndex = 0;
        const recid = this.sourceDiwmodsec.activeRow.data.diwms_recid;
        prow.set( "diwms_recid", recid );
        prow.mode = DataSourceMode.NONE;
        this.sourceDiwmodsec.mode = DataSourceMode.NONE;
        this.sourceDiwmodsec.setRowsAndMode( prow.mode, [prow], null );
        this.sourceDiwmodsec.delete();
      }
    }
  }

  //Start of Web Group Access Logic
  /** This is an event handler for the onRowDisplay event of tblGroupsGA. */
  tblGroupsGAOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDigroupTypeGA") as Textbox;
    const type: string = txtbox.text
    if( type == "API" )
    {
      event.getTableRow().visible = false;
    }
  }

  /** This is an event handler for the onRowDisplay event of tblDbsGA. */
  tblDbsGAOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDidbDescGA") as Textbox;
    let desc: string = txtbox.text
    desc = desc.replace( "&", "" );
    txtbox.text = desc;
  }


/** This is an event handler for the onSelect event of tblGroupsGA. */
  tblGroupsGAOnSelect(event: TableSelectionEvent) {
    this.tblDbsGAOnSelect( event );
  }

/** This is an event handler for the onSelect event of tblDbsGA. */
  async tblDbsGAOnSelect(event: TableSelectionEvent) {
    if( this.tblGroupsGA.selectedRow != null && this.tblDbsGA.selectedRow != null )
    {
      this.tblAppsGA.clearRows();
      const grouprow: any = this.tblGroupsGA.selectedRow.data;
      const didbrow: any = this.tblDbsGA.selectedRow.data;
      const gid = grouprow._data.digroup_gid;
      const gtype = grouprow._data.digroup_type;
      const dbid = didbrow._data.didb_dbalias;
      await this.sourceDiaccess.search( { diaccess_gid: gid, diaccess_dbalias: dbid });
      this.pnl5GA.visible = false;
      if( gtype == "M" )
      {
        this.pnl5GA.visible = true;
        await this.sourceDxmasterp.search( { dxm_dbalias: dbid, dxm_type: gtype });
      }
      await this.sourceImgApps.search( { imap_dbalias: dbid, imap_secbyapp: "Y" });
      await this.sourceDicoldusr.search( { dicou_dbalias: dbid, dicou_gid: gid } );
      await this.sourceColddep.search( { cod_dbalias: dbid } );
      await this.sourceColdcat.search( { coc_dbalias: dbid } );
      this.tblDocTypesGA.clearRows();
    }
  }

/** This is an event handler for the onRowDisplay event of tblAppsGA. */
  tblAppsGAOnRowDisplay(event: TableRowDisplayEvent) {
    const tbappname = event.getTableRow().findComponentById("textboxImapAppnameGA") as Textbox;
    let desc: string = tbappname.text
    desc = desc.replace( "&", "" );
    tbappname.text = desc;

    const tbappid = event.getTableRow().findComponentById("textboxImapAppidGA") as Textbox;
    const appid: string = tbappid.text
    const chkbox = event.getTableRow().findComponentById("cbAppidGA") as Checkbox;
    chkbox.printable = false;
    chkbox.checked = false;
    for( let i: any = 0; i < this.sourceDiaccess.rowCount; i++ )
    {
      this.sourceDiaccess.rowIndex = i;
      const row: any = this.sourceDiaccess.activeRow.data;
      const diappid: any = row.diaccess_appid;
      if( appid == diappid )
      {
        chkbox.checked = true;
        break;
      }
    }
  }

/** This is an event handler for the onRowDisplay event of tblAccessGA. */
  tblAccessGAOnRowDisplay(event: TableRowDisplayEvent) {
    const tbgvalue = event.getTableRow().findComponentById("textboxLvValue") as Textbox;
    const digrant: string = tbgvalue.text

    const chkbox = event.getTableRow().findComponentById("cbAccessGA") as Checkbox;
    chkbox.printable = false;
    chkbox.checked = false;
    for( let i: any = 0; i < this.sourceDiaccess.rowCount; i++ )
    {
      this.sourceDiaccess.rowIndex = i;
      const row: any = this.sourceDiaccess.activeRow.data;
      const gid = row.diaccess_gid;
      const appid = row.diaccess_appid;
      const dbalias = row.diaccess_dbalias;
      const effvolid = row.diaccess_effvolid;
      const filter = row.diaccess_filter;
      const grant: String = row.diaccess_grant;
      const scannerid = row.diaccess_scannerid;
      const wfalias = row.diaccess_wfalias;
      if( grant && grant.includes( digrant ) )
      {
        chkbox.checked = true;
        break;
      }
    }
  }

/** This is an event handler for the onSelect event of tblAppsGA. */
  async tblAppsGAOnSelect(event: TableSelectionEvent) {
    if( this.tblMobAppsGA.selectedRow )
      this.tblMobAppsGA.selectedRow.selected = false;
    this.selectedApp = "Filing Cabinet";
    if( this.tblGroupsGA.selectedRow != null && this.tblDbsGA.selectedRow != null && this.tblAppsGA.selectedRow != null )
    {
      this.tblAccessGA.clearRows();
      this.ClearWorkflow();

      const grouprow: any = this.tblGroupsGA.selectedRow.data;
      const didbrow: any = this.tblDbsGA.selectedRow.data;
      const imaprow: any = this.tblAppsGA.selectedRow.data;
      const gid = grouprow._data.digroup_gid;
      const dbid = didbrow._data.didb_dbalias;
      const appid = imaprow._data.imap_appid;
      const secbyapp = imaprow._data.imap_secbyapp;
      const secbycat = imaprow._data.imap_secbycat;
      await this.sourceDiaccess.search( { diaccess_gid: gid, diaccess_dbalias: dbid, diaccess_appid: appid });
      await this.sourceImglistvalues.search( { lv_table: "diaccess" } );
      await this.sourceImagingMedia.search( { med_devname: "storage" } );
      await this.sourceDiwfuser.search( { diwfusr_dbalias: dbid, diwfusr_gid: gid } );
      await this.sourceDiwfalias.search( { diwfa_dbalias: dbid, diwfa_appid: appid } );
      await this.sourceWfqueue.search( { wfque_dbalias: dbid, wfque_appid: appid } );
      // await this.sourceDicoldusr.search( { dicou_dbalias: dbid, dicou_gid: gid } );
      // await this.sourceColddep.search( { cod_dbalias: dbid } );
      // await this.sourceColdcat.search( { coc_dbalias: dbid } );
      if( secbycat == "Y" )
      {
        await this.sourceDicatsec.search( { dicats_appid: appid, dicats_dbalias: dbid, dicats_gid: gid } );
        await this.sourceImapCats.search( { icat_appid: appid, icat_dbalias: dbid } );
      }
      else
        this.tblDocTypesGA.clearRows();
    }
  }

  ClearWorkflow()
  {
    const chkbox2 = this.tbWorkflow.findComponentById("cbWfAliasGA") as Checkbox;
    chkbox2.checked = false;
    chkbox2.enabled = false;
    const twfalias = this.pnlWorkflow.findComponentById( "textboxDiwfaWfaliasGA" ) as Textbox;
    twfalias.text = "";
    const tdesc = this.pnlWorkflow.findComponentById( "textboxDiwfaDesc" ) as Textbox;
    tdesc.text = "";
  }

/** This is an event handler for the onRowDisplay event of tblVolIdGA. */
  tblVolIdGAOnRowDisplay(event: TableRowDisplayEvent) {
    const trow = event.getTableRow();
    const radio = event.getTableRow().findComponentById("rdVolidGA") as Checkbox;
    const txtbox = event.getTableRow().findComponentById("textboxMedVolid") as Textbox;
    radio.printable = false;
    radio.checked = false;
    radio.valueChecked = txtbox.text;
    for( let i: any = 0; i < this.sourceDiaccess.rowCount; i++ )
    {
      this.sourceDiaccess.rowIndex = i;
      const row: any = this.sourceDiaccess.activeRow.data;
      const gid = row.diaccess_gid;
      const appid = row.diaccess_appid;
      const dbalias = row.diaccess_dbalias;
      const effvolid = row.diaccess_effvolid;
      if( effvolid == txtbox.text )
        radio.checked = true;
    }
  }

/** This is an event handler for the onClick event of rdVolidGA. */
  async rdVolidGAOnClick(event: ClickEvent) {
    const radioclicked: any = event.target;
    for( let i = 0; i < this.tblVolIdGA.rowCount; i++ )
    {
      const trow = this.tblVolIdGA.getRowByIndex(i);
      const radio = trow.findComponentById( "rdVolidGA" ) as Checkbox;
      if( radio != radioclicked )
        radio.checked = false;
    }

    clearInterval(this.timer);
    this.timer = setInterval(() => this.UpdateDiaccess(), 500);
  }

/** This is an event handler for the onRowDisplay event of tblWfqueueGA. */
  tblWfqueueGAOnRowDisplay(event: TableRowDisplayEvent) {
    const chkbox2 = this.tbWorkflow.findComponentById("cbWfAliasGA") as Checkbox;
    chkbox2.checked = false;
    chkbox2.enabled = false;
    const txtwfalias = this.pnlWorkflow.findComponentById( "textboxDiwfaWfaliasGA" ) as Textbox;
    if( txtwfalias && txtwfalias.text.length > 0 )
      chkbox2.enabled = true;
    let diwfalias = "";
    for( let i: any = 0; i < this.sourceDiaccess.rowCount; i++ )
    {
      this.sourceDiaccess.rowIndex = i;
      const row: any = this.sourceDiaccess.activeRow.data;
      const gid = row.diaccess_gid;
      const appid = row.diaccess_appid;
      diwfalias = row.diaccess_wfalias;
      const effvolid = row.diaccess_effvolid;
      if( diwfalias && diwfalias.length > 0 )
        chkbox2.checked = true;
    }

    const chkbox = event.getTableRow().findComponentById("cbQueGA") as Checkbox;
    //const txtbox = event.getTableRow().findComponentById("textboxMedVolid") as Textbox;
    chkbox.printable = false;
    chkbox.checked = false;
    const txtbox = event.getTableRow().findComponentById("textboxWfqueQueueid") as Textbox;
    const qid = txtbox.text;
    for( let i: any = 0; i < this.sourceDiwfuser.rowCount; i++ )
    {
      this.sourceDiwfuser.rowIndex = i;
      const row: any = this.sourceDiwfuser.activeRow.data;
      const gid = row.diwfusr_gid;
      const queid = row.diwfusr_queueid;
      const wfalias = row.diwfusr_wfalias;
      if( qid == queid && diwfalias == wfalias )
      {
        chkbox.checked = true;
        break;
      }
    }
  }

/** This is an event handler for the onRowDisplay event of tblDeptsGA. */
  tblDeptsGAOnRowDisplay(event: TableRowDisplayEvent) {
    const chkbox = event.getTableRow().findComponentById("chkboxDeptsGA") as Checkbox;
    chkbox.printable = false;
    chkbox.checked = false;
    const txtbox = event.getTableRow().findComponentById("textboxCodDindex") as Textbox;
    const dindex = txtbox.text;
    for( let i: any = 0; i < this.sourceDicoldusr.rowCount; i++ )
    {
      this.sourceDicoldusr.rowIndex = i;
      const row: any = this.sourceDicoldusr.activeRow.data;
      const gid = row.dicou_gid;
      const dbalias = row.dicou_dbalias;
      const didx = row.dicou_dindex;
      const cidx = row.dicou_cindex;
      if( dindex == didx )
      {
        chkbox.checked = true;
        break;
      }
    }
  }

/** This is an event handler for the onRowDisplay event of tblCatgsGA. */
  tblCatgsGAOnRowDisplay(event: TableRowDisplayEvent) {
    const chkbox = event.getTableRow().findComponentById("chkboxCatgsGA") as Checkbox;
    chkbox.printable = false;
    chkbox.checked = false;
    const txtbox = event.getTableRow().findComponentById("textboxCocDindex") as Textbox;
    const dindex = txtbox.text;
    for( let i: any = 0; i < this.sourceColddep.rowCount; i++ )
    {
      this.sourceColddep.rowIndex = i;
      const row: any = this.sourceColddep.activeRow.data;
      const didx = row.cod_dindex;
      const odesc = row.cod_depdesc;
      if( didx == dindex )
      {
        const txtbox2 = event.getTableRow().findComponentById("textboxCocCatdesc") as Textbox;
        const desc = row.cod_depdesc + " - " + txtbox2.text;
        txtbox2.text = desc;
        break;
      }
    }
    const txtbox2 = event.getTableRow().findComponentById("textboxCocCindex") as Textbox;
    const cindex = txtbox2.text;
    for( let i: any = 0; i < this.sourceDicoldusr.rowCount; i++ )
    {
      this.sourceDicoldusr.rowIndex = i;
      const row: any = this.sourceDicoldusr.activeRow.data;
      const gid = row.dicou_gid;
      const dbalias = row.dicou_dbalias;
      const didx = row.dicou_dindex;
      const cidx = row.dicou_cindex;
      if( dindex == didx && cindex == cidx )
      {
        chkbox.checked = true;
        break;
      }
    }
  }

/** This is an event handler for the onRowDisplay event of tblDocTypesGA. */
  tblDocTypesGAOnRowDisplay(event: TableRowDisplayEvent) {
    const chkbox = event.getTableRow().findComponentById("chkboxDocTypesGA") as Checkbox;
    chkbox.printable = false;
    chkbox.checked = false;
    const txtbox = event.getTableRow().findComponentById("textboxIcatCatid") as Textbox;
    const icatid = txtbox.text;
    const txtbox2 = event.getTableRow().findComponentById("textboxIcatCatdesc") as Textbox;
    let idesc: string = txtbox2.text;
    idesc = idesc.replace( "&", "" );
    txtbox2.text = idesc;
    for( let i: any = 0; i < this.sourceDicatsec.rowCount; i++ )
    {
      this.sourceDicatsec.rowIndex = i;
      const row: any = this.sourceDicatsec.activeRow.data;
      const gid = row.dicats_gid;
      const dbalias = row.dicats_dbalias;
      const appid = row.dicats_appid;
      const catid = row.dicats_catid;
      if( icatid == catid )
      {
        chkbox.checked = true;
        break;
      }
    }
  }

/** This is an event handler for the onClick event of cbAppidGA. */
  async cbAppidGAOnClick(event: ClickEvent) {
    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    this.tblAppsGA.selectRow( chkbox.row, SelectionType.SINGLE, null );
    const grouprow: any = this.tblGroupsGA.selectedRow.data;
    const didbrow: any = this.tblDbsGA.selectedRow.data;
    const gid = grouprow._data.digroup_gid;
    const dbid = didbrow._data.didb_dbalias;
    const appid = row._data.imap_appid;
    const appname = row._data.imap_appname;
    const scannerid = this.GetScannerid();
    const filter = this.GetFilter();
    const wfalias = ""; //this.GetWfalias();

    const prow: any = new ModelRow("imaging/AccessAdmin/diaccess", true);
    prow.set( "diaccess_gid", gid );
    prow.set( "diaccess_dbalias", dbid );
    prow.set( "diaccess_appid", appid );
    const resp = await this.sourceDiaccess.search( prow );
    if( chkbox.checked || this.sourceDiaccess.rowCount == 0 )
    {   //add row to diaccess Security
      const grant = this.GetGrantAccess();
      prow.set( "diaccess_grant", grant );
      const volid = this.GetVolid();
      prow.set( "diaccess_effvolid", volid );
      // const scannerid = this.GetScannerid();
      prow.set( "diaccess_scannerid", scannerid );
      prow.set( "diaccess_filter", filter );
      prow.set( "diaccess_wfalias", wfalias );
      prow.mode = DataSourceMode.ADD;
      this.sourceDiaccess.mode = DataSourceMode.ADD;
      this.sourceDiaccess.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDiaccess.post();
    }
    else
    {   //delete row diaccess Security
      if( resp != null && this.sourceDiaccess.rowCount == 1 )
      {
        const mrow: any = resp.modelRows[0];
        mrow.mode = DataSourceMode.NONE;
        this.sourceDiaccess.mode = DataSourceMode.NONE;
        this.sourceDiaccess.setRowsAndMode( mrow.mode, [mrow], null );
        this.sourceDiaccess.delete();
        // await this.DeleteDiwfuser( gid, dbid, appid, wfalias );
        // await this.DeleteDicatsec( gid, dbid, appid, wfalias );
      }
    }
  }

  GetFilter()
  {
    let filter = "";
    const txtfilter = this.pnlAccessGA3.findComponentById( "textboxDiaccessFilter" ) as Textbox;
    if( txtfilter )
      filter = txtfilter.text;
    return( filter );
  }

  GetWfalias()
  {
    const txtwfalias = this.pnlWorkflow.findComponentById( "textboxDiwfaWfaliasGA" ) as Textbox;
    const chkwfalias = this.pnlWorkflow.findComponentById( "cbWfAliasGA" ) as Checkbox;
    let wfalias = "";
    if( chkwfalias && chkwfalias.checked )
      wfalias = txtwfalias.text;
    return( wfalias );
  }

  GetGrantAccess()
  {
    let grant = "";
    for( let i = 0; i < this.tblAccessGA.rowCount; i++ )
    {
      const trow = this.tblAccessGA.getRowByIndex(i);
      const trowd = trow.data._data;
      const chkbox = trow.findComponentById( "cbAccessGA" ) as Checkbox;
      if( chkbox && chkbox.checked )
        grant += trowd.lv_value;
    }
    return( grant );
  }

  GetVolid()
  {
    let volid = "";
    for( let i = 0; i < this.tblVolIdGA.rowCount; i++ )
    {
      const trow = this.tblVolIdGA.getRowByIndex(i);
      const trowd = trow.data._data;
      const radio = trow.findComponentById( "rdVolidGA" ) as Checkbox;
      if( radio && radio.checked )
      {
        volid = trowd.med_volid;
        break;
      }
    }
    return( volid );
  }

  GetScannerid()
  {
    let scannerid = "";
    for( let i = 0; i < this.pnlAccessGA3.getComponentCount(); i++ )
    {
      const radio = this.pnlAccessGA3.getComponent(i) as RadioGroup;
      if( radio && radio.selectedValue )
      {
        scannerid = radio.selectedValue;
        break;
      }
    }
    return( scannerid );
  }

  async UpdateDiaccess() {
    clearInterval(this.timer);
    const grouprow: any = this.tblGroupsGA.selectedRow.data;
    const didbrow: any = this.tblDbsGA.selectedRow.data;
    const gtype = grouprow._data.digroup_type;
    let approw: any = null;
    let appid = "";
    let appname = "";
    if( this.selectedApp == "Filing Cabinet" )
    {
      approw = this.tblAppsGA.selectedRow.data;
      appid = approw._data.imap_appid;
      appname = approw._data.imap_appname;
    }
    else if( this.selectedApp == "Mobile Module" )
    {
      approw = this.tblMobAppsGA.selectedRow.data;
      appid = approw._data.dxm_id;
      appname = approw._data.dxm_name;
    }
    else
      return;
    const gid = grouprow._data.digroup_gid;
    const dbid = didbrow._data.didb_dbalias;
    const filter = this.GetFilter();
    const wfalias = this.GetWfalias();
    const grant = this.GetGrantAccess();
    const volid = this.GetVolid();
    const scannerid = this.GetScannerid();

    const prow: any = new ModelRow("imaging/AccessAdmin/diaccess", true);
    prow.set( "diaccess_gid", gid );
    prow.set( "diaccess_dbalias", dbid );
    prow.set( "diaccess_appid", appid );
    const resp = await this.sourceDiaccess.search( prow );
    if( resp && this.sourceDiaccess.rowCount == 1 )
    {   //update row in diaccess Security
      const mrow: any = resp.modelRows[0];
      const owfalias = mrow._data.diaccess_wfalias;
      mrow.set( "diaccess_scannerid", scannerid );
      mrow.set( "diaccess_filter", filter );
      mrow.set( "diaccess_grant", grant );
      mrow.set( "diaccess_effvolid", volid );
      mrow.set( "diaccess_wfalias", wfalias );
      mrow.mode = DataSourceMode.UPDATE;
      this.sourceDiaccess.setRowsAndMode( mrow.mode, [mrow], null );
      await this.sourceDiaccess.post();
      // if( owfalias && wfalias.length <= 0 && owfalias.length > 0 )
      //   await this.DeleteDiwfuser( gid, dbid, appid, owfalias );
      if( this.scanneridUpdate == false )
      {
        if( this.selectedApp == "Filing Cabinet" )
          await this.tblAppsGAOnSelect(null); //refresh display
        else if( this.selectedApp == "Mobile Module" )
          await this.tblMobAppsGAOnSelect(null); //refresh display
      }
      this.scanneridUpdate = false;
    }
  }

  async DeleteDiwfuser( gid: any, dbid: any, appid: any, owfalias: any ) {
    if( gid && owfalias && gid.length > 0 && owfalias.length > 0 )
    {
      const prow: any = new ModelRow("imaging/AccessAdmin/diwfuser", true);
      prow.set( "diwfusr_gid", gid );
      prow.set( "diwfusr_wfalias", owfalias );
      const resp = await this.sourceDiwfuser.search( prow );
      if( resp && this.sourceDiwfuser.rowCount > 0 )
      {   //delete all rows in diwfuser Security
        for( let i = 0; i < resp.modelRows.length; i++ )
        {
          const mrow: any = resp.modelRows[i];
          mrow.mode = DataSourceMode.NONE;
          this.sourceDiwfuser.mode = DataSourceMode.NONE;
          this.sourceDiwfuser.setRowsAndMode( mrow.mode, [mrow], null );
          this.sourceDiwfuser.delete();
        }
      }
    }
  }

  async DeleteDicatsec( gid: any, dbid: any, appid: any, owfalias: any ) {
    if( gid && dbid && appid && gid.length > 0 && dbid.length > 0 && appid.length > 0 )
    {
      const prow: any = new ModelRow("imaging/AccessAdmin/dicatsec", true);
      prow.set( "dicats_gid", gid );
      prow.set( "dicats_dbalias", dbid );
      prow.set( "dicats_appid", appid );
      const resp = await this.sourceDicatsec.search( prow );
      if( resp && this.sourceDicatsec.rowCount > 0 )
      {   //delete all rows in dicatsec Security
        for( let i = 0; i < resp.modelRows.length; i++ )
        {
          const mrow: any = resp.modelRows[i];
          mrow.mode = DataSourceMode.NONE;
          this.sourceDicatsec.mode = DataSourceMode.NONE;
          this.sourceDicatsec.setRowsAndMode( mrow.mode, [mrow], null );
          this.sourceDicatsec.delete();
        }
      }
    }
  }

/** This is an event handler for the onClick event of cbAccessGA. */
  async cbAccessGAOnClick(event: ClickEvent) {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.UpdateDiaccess(), 500);
  }

/** This is an event handler for the onClick event of cbWfAliasGA. */
  async cbWfAliasGAOnClick(event: ClickEvent) {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.UpdateDiaccess(), 500);
  }

/** This is an event handler for the onClick event of cbQueGA. */
  async cbQueGAOnClick(event: ClickEvent) {
    const grouprow: any = this.tblGroupsGA.selectedRow.data;
    const didbrow: any = this.tblDbsGA.selectedRow.data;
    const approw: any = this.tblAppsGA.selectedRow.data;
    const gid = grouprow._data.digroup_gid;
    const dbid = didbrow._data.didb_dbalias;
    const appid = approw._data.imap_appid;
    const appname = approw._data.imap_appname;
    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    const queid = row._data.wfque_queueid;

    const prow: any = new ModelRow("imaging/AccessAdmin/diwfuser", true);
    const wfalias = this.GetWfalias();
    prow.set( "diwfusr_wfalias", wfalias );
    prow.set( "diwfusr_gid", gid );
    prow.set( "diwfusr_queueid", queid );
    const resp = await this.sourceDiwfuser.search( prow );
    if( chkbox.checked || this.sourceDiwfuser.rowCount == 0 )
    {   //add row to diwfuser
      prow.set( "diwfusr_status", "A" );
      prow.mode = DataSourceMode.ADD;
      this.sourceDiwfuser.mode = DataSourceMode.ADD;
      this.sourceDiwfuser.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDiwfuser.post();
    }
    else
    {   //delete row
      if( resp != null && this.sourceDiwfuser.rowCount == 1 )
      {
        const mrow: any = resp.modelRows[0];
        mrow.mode = DataSourceMode.NONE;
        this.sourceDiwfuser.mode = DataSourceMode.NONE;
        this.sourceDiwfuser.setRowsAndMode( mrow.mode, [mrow], null );
        this.sourceDiwfuser.delete();
      }
    }
  }

/** This is an event handler for the onClick event of Scanner Id Radio buttons. */
  rdScannerIdOnClick(event: ClickEvent) {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.UpdateDiaccess(), 500);
  }

/** This is an event handler for the onClick event of chkboxDeptsGA. */
  async chkboxDeptsGAOnClick(event: ClickEvent) {
    const grouprow: any = this.tblGroupsGA.selectedRow.data;
    const didbrow: any = this.tblDbsGA.selectedRow.data;
    const gid = grouprow._data.digroup_gid;
    const dbid = didbrow._data.didb_dbalias;
    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    const dindex = row._data.cod_dindex;

    const prow: any = new ModelRow("imaging/AccessAdmin/dicoldusr", true);
    prow.set( "dicou_dbalias", dbid );
    prow.set( "dicou_gid", gid );
    prow.set( "dicou_dindex", dindex );
    const resp = await this.sourceDicoldusr.search( prow );
    if( resp != null && this.sourceDicoldusr.rowCount > 0 )
    { //delete all rows from dicoldusr
      for( let i = 0; i < resp.modelRows.length; i++ )
      {
        const mrow: any = resp.modelRows[i];
        mrow.mode = DataSourceMode.NONE;
        this.sourceDicoldusr.mode = DataSourceMode.NONE;
        this.sourceDicoldusr.setRowsAndMode( mrow.mode, [mrow], null );
        this.sourceDicoldusr.delete();
      }
      await this.tblDbsGAOnSelect(null); //refresh display
    }
  }

/** This is an event handler for the onClick event of chkboxCatgsGA. */
  async chkboxCatgsGAOnClick(event: ClickEvent) {
    const grouprow: any = this.tblGroupsGA.selectedRow.data;
    const didbrow: any = this.tblDbsGA.selectedRow.data;
    const gid = grouprow._data.digroup_gid;
    const dbid = didbrow._data.didb_dbalias;
    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    const dindex = row._data.coc_dindex;
    const cindex = row._data.coc_cindex;

    const prow: any = new ModelRow("imaging/AccessAdmin/dicoldusr", true);
    prow.set( "dicou_dbalias", dbid );
    prow.set( "dicou_gid", gid );
    prow.set( "dicou_dindex", dindex );
    prow.set( "dicou_cindex", cindex );
    const resp = await this.sourceDicoldusr.search( prow );
    if( chkbox.checked || this.sourceDicoldusr.rowCount == 0 )
    { //Add row to dicoldusr
      prow.mode = DataSourceMode.ADD;
      this.sourceDicoldusr.mode = DataSourceMode.ADD;
      this.sourceDicoldusr.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDicoldusr.post();
    }
    else if( resp != null && this.sourceDicoldusr.rowCount == 1 )
    { //delete row from dicoldusr
      const mrow: any = resp.modelRows[0];
      mrow.mode = DataSourceMode.NONE;
      this.sourceDicoldusr.mode = DataSourceMode.NONE;
      this.sourceDicoldusr.setRowsAndMode( mrow.mode, [mrow], null );
      this.sourceDicoldusr.delete();
    }
    await this.tblDbsGAOnSelect(null); //refresh display
  }

/** This is an event handler for the onClick event of chkboxDocTypesGA. */
  async chkboxDocTypesGAOnClick(event: ClickEvent) {
    const grouprow: any = this.tblGroupsGA.selectedRow.data;
    const didbrow: any = this.tblDbsGA.selectedRow.data;
    const gid = grouprow._data.digroup_gid;
    const dbid = didbrow._data.didb_dbalias;
    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    const catid = row._data.icat_catid;
    const appid = row._data.icat_appid;

    const prow: any = new ModelRow("imaging/AccessAdmin/dicatsec", true);
    prow.set( "dicats_dbalias", dbid );
    prow.set( "dicats_gid", gid );
    prow.set( "dicats_appid", appid );
    prow.set( "dicats_catid", catid );
    const resp = await this.sourceDicatsec.search( prow );
    if( chkbox.checked || this.sourceDicatsec.rowCount == 0 )
    { //Add row to dicatsec
      prow.mode = DataSourceMode.ADD;
      this.sourceDicatsec.mode = DataSourceMode.ADD;
      this.sourceDicatsec.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDicatsec.post();
    }
    else if( resp != null && this.sourceDicatsec.rowCount == 1 )
    { //delete row from dicatsec
      const mrow: any = resp.modelRows[0];
      mrow.mode = DataSourceMode.NONE;
      this.sourceDicatsec.mode = DataSourceMode.NONE;
      this.sourceDicatsec.setRowsAndMode( mrow.mode, [mrow], null );
      this.sourceDicatsec.delete();
    }
  }

/** This is an event handler for the onRowDisplay event of tblMobAppsGA. */
  tblMobAppsGAOnRowDisplay(event: TableRowDisplayEvent) {
    const chkbox = event.getTableRow().findComponentById("checkboxMobModuleGA") as Checkbox;
    chkbox.printable = false;
    chkbox.checked = false;
    const tbappname = event.getTableRow().findComponentById("textboxDxmNameGA") as Textbox;
    let desc: string = tbappname.text
    desc = desc.replace( "&", "" );
    tbappname.text = desc;

    const tbappid = event.getTableRow().findComponentById("textboxDxmIdGA") as Textbox;
    const appid: string = tbappid.text
    for( let i: any = 0; i < this.sourceDiaccess.rowCount; i++ )
    {
      this.sourceDiaccess.rowIndex = i;
      const row: any = this.sourceDiaccess.activeRow.data;
      const diappid: any = row.diaccess_appid;
      if( appid == diappid )
      {
        chkbox.checked = true;
        break;
      }
    }
  }

/** This is an event handler for the onSelect event of tblMobAppsGA. */
  async tblMobAppsGAOnSelect(event: TableSelectionEvent) {
    if( this.tblAppsGA.selectedRow )
      this.tblAppsGA.selectedRow.selected = false;
    this.selectedApp = "Mobile Module";
    if( this.tblGroupsGA.selectedRow != null && this.tblDbsGA.selectedRow != null && this.tblMobAppsGA.selectedRow != null )
    {
      this.tblAccessGA.clearRows();
      this.ClearWorkflow();

      const grouprow: any = this.tblGroupsGA.selectedRow.data;
      const didbrow: any = this.tblDbsGA.selectedRow.data;
      const dxmrow: any = this.tblMobAppsGA.selectedRow.data;
      const gid = grouprow._data.digroup_gid;
      const dbid = didbrow._data.didb_dbalias;
      const appid = dxmrow._data.dxm_id;
      const appname = dxmrow._data.dxm_name;
      const apptype = dxmrow._data.dxm_type;
      await this.sourceDiaccess.search( { diaccess_gid: gid, diaccess_dbalias: dbid, diaccess_appid: appid });
      await this.sourceImglistvalues.search( { lv_table: "diaccess" } );
      await this.sourceImagingMedia.search( { med_devname: "storage" } );
      await this.sourceDiwfuser.search( { diwfusr_dbalias: dbid, diwfusr_gid: gid } );
      await this.sourceDiwfalias.search( { diwfa_dbalias: dbid, diwfa_appid: appid } );
      await this.sourceWfqueue.search( { wfque_dbalias: dbid, wfque_appid: appid } );
      // await this.sourceDicoldusr.search( { dicou_dbalias: dbid, dicou_gid: gid } );
      // await this.sourceColddep.search( { cod_dbalias: dbid } );
      // await this.sourceColdcat.search( { coc_dbalias: dbid } );
      //if( secbycat == "Y" )
      {
        await this.sourceDicatsec.search( { dicats_appid: appid, dicats_dbalias: dbid, dicats_gid: gid } );
        await this.sourceImapCats.search( { icat_appid: appid, icat_dbalias: dbid } );
      }
      //else
      //  this.tblDocTypesGA.clearRows();
    }
  }

/** This is an event handler for the onClick event of checkboxMobModuleGA. */
  async checkboxMobModuleGAOnClick(event: ClickEvent) {
    const chkbox: any = event.target as Checkbox;
    const row = chkbox.row.data;
    this.tblMobAppsGA.selectRow( chkbox.row, SelectionType.SINGLE, null );
    const grouprow: any = this.tblGroupsGA.selectedRow.data;
    const didbrow: any = this.tblDbsGA.selectedRow.data;
    const gid = grouprow._data.digroup_gid;
    const dbid = didbrow._data.didb_dbalias;
    const appid = row._data.dxm_id;
    const appname = row._data.dxm_name;
    const scannerid = this.GetScannerid();
    const filter = this.GetFilter();
    const wfalias = ""; //this.GetWfalias();

    const prow: any = new ModelRow("imaging/AccessAdmin/diaccess", true);
    prow.set( "diaccess_gid", gid );
    prow.set( "diaccess_dbalias", dbid );
    prow.set( "diaccess_appid", appid );
    const resp = await this.sourceDiaccess.search( prow );
    if( chkbox.checked || this.sourceDiaccess.rowCount == 0 )
    {   //add row to diaccess Security
      const grant = this.GetGrantAccess();
      prow.set( "diaccess_grant", grant );
      const volid = this.GetVolid();
      prow.set( "diaccess_effvolid", volid );
      // const scannerid = this.GetScannerid();
      prow.set( "diaccess_scannerid", scannerid );
      prow.set( "diaccess_filter", filter );
      prow.set( "diaccess_wfalias", wfalias );
      prow.mode = DataSourceMode.ADD;
      this.sourceDiaccess.mode = DataSourceMode.ADD;
      this.sourceDiaccess.setRowsAndMode( prow.mode, [prow], null );
      await this.sourceDiaccess.post();
    }
    else
    {   //delete row diaccess Security
      if( resp != null && this.sourceDiaccess.rowCount == 1 )
      {
        const mrow: any = resp.modelRows[0];
        mrow.mode = DataSourceMode.NONE;
        this.sourceDiaccess.mode = DataSourceMode.NONE;
        this.sourceDiaccess.setRowsAndMode( mrow.mode, [mrow], null );
        this.sourceDiaccess.delete();
        // await this.DeleteDiwfuser( gid, dbid, appid, wfalias );
        // await this.DeleteDicatsec( gid, dbid, appid, wfalias );
      }
    }
  }

/** This is an event handler for the afterSelection event of scanneridRG. */
  scanneridRGAfterSelection(event: RadioButtonSelectionEvent) {
    if( event.domEvent )
    {   //selected from dom
        this.scanneridUpdate = true;
        clearInterval(this.timer);
        this.timer = setInterval(() => this.UpdateDiaccess(), 500);
    }
  }

}
